import axios from "axios";
import router from "../router";
import { BreedingRhombusSpinner } from "epic-spinners";

export default {
  namespaced: true,
  state: {
    srcImage: "",
    // formIsValid: false, //habilitar boton editar o crear
    alertModalSettings: {
      active: false,
      err: ""
    },
    showRightMenu: false, // right menu closed
    isEditing: false, // watches if we are on editing mode on right menu
    //users:
    allUsers: [],
    oneUserDetails: {},
    showUserDetails: false, //show user details on right menu
    typeRoles: [
      { value: 1, type: "admin", name: "ADMIN" },
      { value: 2, type: "operationsManager", name: "MANAGER OPERACIONES" },
      { value: 3, type: "inSituManager", name: "MANAGER IN SITU" },
      { value: 3, type: "digitalManager", name: "MANAGER DIGITAL" },
      { value: 5, type: "provider", name: "PROVEEDOR (IMPRESIÓN)" },
      { value: 6, type: "commercialManager", name: "MANAGER COMERCIAL" },
      { value: 7, type: "salesExecutive", name: "EJECUTIVO VENTA" },
      { value: 8, type: "report", name: "REPORT USER" },
      { value: 9, type: "provider", name: "AENA" }
    ],

    //clients:
    allClients: [],
    oneClientDetails: {},
    showClientDetails: false, //shows DETAILS (not editables)
    arrMainContact: [],
    changeMainContact: false,
    accountExecutives: [],

    //Providers:
    allProviders: [],
    oneProviderDetails: {},
    showProviderDetails: false, //shows DETAILS (not editables)

    // Projects
    oneProjectDetails: [],

  },
  mutations: {
    srcImageMutation(state, data) {
      state.srcImage = data;
    },
    setIsEditing(state, bool) {
      state.isEditing = bool;
    },
    // validar formulario para habilitar el botón editar o crear: (ya no lo usamos)
    formIsValidMutation(state, bool) {
      state.formIsValid = bool;
    },
    openRightMenuMutation(state) {
      state.showRightMenu = true;
    },
    closeRightMenuMutation(state) {
      state.showRightMenu = false;
      console.log('closeRightMenuMutation')
      console.log(state.showRightMenu)
      // state.oneClientDetails = {} //when closing, empty the object
      // state.oneUserDetails = {} //when closing, empty the object
      state.srcImage = "";
    },
    changeAlertModal(state, err) {
      state.alertModalSettings.active = true;
      state.alertModalSettings.err = err.response.data.result[0].msg;
    },

    /** USERS: */
    //Crear, leer, actualizar, borrar

    allUsers(state, users) {
      state.allUsers = users;
    },
    setUserStore(state) {
      state.oneUserDetails = {};
    },
    setUserDetails(state, userDetails) {
      state.srcImage = "";
      state.oneUserDetails = userDetails;
    },
    ShowUserDetailMutation(state, data) {
      state.showUserDetails = data;
    },


    /** CLIENTS: */
    //Crear, leer, actualizar, borrar
    allClients(state, clients) {
      state.allClients = clients;
    },
    setClientDetails(state, clientDetails) {
      state.srcImage = "";
      state.oneClientDetails = clientDetails;

      // Añadimos los datos completos de los usuarios seleccionados
      if (clientDetails.users != undefined) {
        state.oneClientDetails["selectedUsers"] = [];
        let contact;
        clientDetails.users.forEach(selectedUser => {
          contact = state.allUsers.find(
            element => element.idUser == selectedUser
          );
          state.oneClientDetails["selectedUsers"].push(contact);
        });
      }
    },
    setMainContactClient(state) {
      state.arrMainContact = [];
      state.changeMainContact = false;
    },
    setAccountExecutives(state, data) {
      state.accountExecutives = data
      console.log(data)
    },

    /** PROVIDERS: */
    //Crear, leer, actualizar, borrar
    allProviders(state, providers) {
      state.allProviders = providers;
    },
    setProviderDetails(state, providerDetails) {
      state.srcImage = "";
      state.oneProviderDetails = providerDetails;

      // Añadimos los datos completos de los usuarios seleccionados
      if (providerDetails.users != undefined) {
        state.oneProviderDetails["selectedUsers"] = [];
        let contact;
        providerDetails.users.forEach(selectedUser => {
          contact = state.allUsers.find(
            element => element.idUser == selectedUser
          );
          state.oneProviderDetails["selectedUsers"].push(contact);
        });
      }
    },

    /** PROJECTS **/
    //Crear, leer, actualizar, borrar
    setProjectDetails(state, projectDetails) {
      if (projectDetails.length == 0) {
        state.oneProjectDetails = [
          {
            idProject: 4511,
            name: "NB Media"
          }
        ];
      } else {
        state.oneProjectDetails = projectDetails;
      }
    }
  },
  actions: {
    cleanUserStore({ commit, dispatch }) {
      commit("setUserStore");
    },
    changeAlertModalStore({ commit }, err) {
      commit("changeAlertModal", err);
    },
    /** USERS: */
    //Crear, leer, actualizar, borrar

    // POST user

    async postNewUserStore({ commit, dispatch }, data) {
      try {
        let response = await axios.post("/Ausers/", data);
        let result = response.data
        dispatch("getAllUsers");
        return result;
      } catch (err) {
        console.log(err);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },

    // GET Obtener todos los users
    async getAllUsers({ commit }) {
      try {
        let response = await axios.get("/Ausers/");
        let result = response.data;
        commit("allUsers", result);
        return result;
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },
    async getUsersByRol({ commit }, rolId) {
      console.log(commit, rolId)
      console.log('rol')
      try {
        let response = await axios.get(`/Ausers/rol/${rolId}`);
        let result = response.data;
        commit("setAccountExecutives", result);
        console.log(response.data);

        return result;
      } catch (err) {
        console.log(err);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },
    async getAllMediaGroups({ commit }) {
      try {
        let response = await axios.get("/Amediagroups/");
        let result = response.data;
        commit("setAllMediaGroups", result);
        return result;
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },
    //GET one User
    async getUserStore({ commit }, id) {
      try {
        let response = await axios.get(`/Ausers/${id}`);
        let result = response.data;
        commit("setUserDetails", response.data);
        return result;
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },
    async getMyDetails() {
      try {
        let response = await axios.get(`/Ausers/me/get/me`);
        let result = response.data;
        console.log(response.data)
        // commit("setUserDetails", response.data);
        return result;
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },

    //PUT user
    async putUserStore({ commit, dispatch }, form_data) {
      try {
        let id = "";
        for (var pair of form_data.entries()) {
          // console.log(pair[0] + ", " + pair[1]);
          if (pair[0] == "idUser") {
            id = pair[1];
          }
        }
        let response = await axios.put(`/Ausers/${id}`, form_data);
        let result = response.data;
        console.log(result)
        dispatch("getAllUsers");
        return result;
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result[0]);
      }

    },

    // DELETE one or more users
    deleteSelectedUsersStore({ commit, dispatch }, data) {
      let idsArr = [];
      data.forEach(data => {
        idsArr.push(data.idUser);
      });
      axios
        .delete("/Ausers", {
          data: {
            ids: idsArr
          }
        })
        .then(response => {
          dispatch("getAllUsers");
          commit("setUserDetails", []);
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    /** CLIENTS: */

    // POST new Client
    async postNewClientStore({ commit, dispatch }, data) {

      try {
        let response = await axios.post("/Aclients/", data);
        let result = response.data
        dispatch("getAllClients");
        return result;
      } catch (err) {
        console.log(err);
        commit("changeAlertModal", err.response.data.result[0]);
      }

    },

    // GET  one Client
    getClientStore({ commit }, id) {
      axios
        .get(`/Aclients/${id}`)
        .then(response => {
          commit("setClientDetails", response.data);
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    // GET all Clients
    getAllClients({ commit }) {
      axios
        .get("/Aclients/")
        .then(response => {
          commit("allClients", response.data);
        })
        .catch(err => {
          console.log(err.response.data);
        });
    },

    // PUT Client
    async putClientStore({ commit, dispatch }, form_data) {
  
      try {
        let id = "";
        for (var pair of form_data.entries()) {
          // console.log(pair[0] + ", " + pair[1]);
          if (pair[0] == "idClient") {
            id = pair[1];
          }
        }
        let response = await axios.put(`/Aclients/${id}`, form_data);
        let result = response.data;
        console.log(result)
        dispatch("getAllClients");
        return result;
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result[0]);
      }
      
    },

    // DELETE one or more clients
    deleteSelectedClientsStore({ commit, dispatch }, data) {
      let idsArr = [];
      data.forEach(data => {
        idsArr.push(data.idClient);
      });
      axios
        .delete("/Aclients", {
          data: {
            ids: idsArr
          }
        })
        .then(response => {
          dispatch("getAllClients");
          commit("setClientDetails", []);
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    /** PROVIDERS: */

    // POST new Provider
    async postNewProviderStore({ commit, dispatch }, data) {
      console.log("HOLAAAA")
      try {
        let response = await axios.post("/Aproviders/", data);
        let result = response.data
        dispatch("getAllProviders");
        return result;
      } catch (err) {
        console.log(err);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },

    // GET  one Provider
    getProviderStore({ commit }, id) {
      axios
        .get(`/Aproviders/${id}`)
        .then(response => {
          commit("setProviderDetails", response.data);
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    // GET all Providers
    getAllProviders({ commit }) {
      axios
        .get("/Aproviders/")
        .then(response => {
          commit("allProviders", response.data);
        })
        .catch(err => {
          console.log(err.response.data);
        });
    },

    // PUT Provider
    async putProviderStore({ commit, dispatch }, form_data) {
      try {
        let id = "";
        for (var pair of form_data.entries()) {
          // console.log(pair[0] + ", " + pair[1]);
          if (pair[0] == "idProvider") {
            id = pair[1];
          }
        }
        let response = await axios.put(`/Aproviders/${id}`, form_data);
        let result = response.data;
        console.log(result)
        dispatch("getAllProviders");
        return result;
      } catch (err) {
        console.log(err.response.data);
        commit("changeAlertModal", err.response.data.result[0]);
      }
    },

    // DELETE one or more Providers
    deleteSelectedProvidersStore({ commit, dispatch }, data) {
      let idsArr = [];
      data.forEach(data => {
        idsArr.push(data.idProvider);
      });
      console.log(idsArr);
      axios
        .delete("/Aproviders", {
          data: {
            ids: idsArr
          }
        })
        .then(response => {
          dispatch("getAllProviders");
          commit("setProviderDetails", []);
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    /** Projects **/

    // POST new Project
    postNewProjectStore({ commit, dispatch }, data) {
      axios
        .post("/Aprojects/", data)
        .then(response => {
          dispatch("getOneProjectStore");
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    },

    // GET  one Project
    getOneProjectStore({ commit }) {
      axios
        .get(`/Aprojects/4511`)
        .then(response => {
          commit("setProjectDetails", response.data);
        })
        .catch(err => {
          console.log(err.response.data);
          commit("changeAlertModal", err.response.data.result[0]);
        });
    }
  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/settings.js